module.exports = __webpack_public_path__ + "img/07_bill_42px_42px_00.1da5b7c4.png";